<template>
    <div id="addFormModal" class="modal add-form-modal fade" v-bind:class="{active: isShow, in: this.isShowModal}" @click.self="close">
        <div class="modal-dialog" style="width: 700px;">
            <div class="modal-content">
                <div class="common-modal-close" @click="close">
                    <img src="../../assets/modal-close.png">
                </div>
                <div class="modal-body">
                    <div class="coupon_modal_hd">{{title}}联系人/乘客</div>
                    <div class="coupon_modal_bd">
                        <form class="form-horizontal">
                            <div class="row">
                                <div>
                                    <label class="control-label">国家或地区</label>
                                    <select v-model="person.country" name="nationality" data-key="Country" class="nationality" @click="countryClick">
                                        <option
                                            v-for="item in nationList"
                                            :key="item.id"
                                            :value="item.countryCode"
                                            :selected="item.countryCode === person.country"
                                        >{{item.countryName}}</option>
                                    </select>
                                </div>
                                <div class="col-xs-6">
                                    <div class="form-group">
                                        <label class="col-sm-3 control-label">中文姓</label>
                                        <div class="col-sm-9">
                                            <input
                                                v-model="person.chineseLastName"
                                                name="ChineseLastName"
                                                data-key="ChineseLastName"
                                                type="text"
                                                class="form-control"
                                                placeholder="必须与护照一致"
                                                autocomplete="off"
                                                @change="handlerLastName"
                                                @focus="txtFocus"
                                            >
                                        </div>
                                    </div>
                                </div>
                                <div class="col-xs-6">
                                    <div class="form-group">
                                        <label class="col-sm-3 control-label">中文名</label>
                                        <div class="col-sm-9">
                                            <input
                                                v-model="person.chineseFirstName"
                                                name="ChineseFirstName"
                                                data-key="ChineseFirstName"
                                                type="text"
                                                class="form-control"
                                                placeholder="必须与护照一致"
                                                autocomplete="off"
                                                @change="handlerFirstName"
                                                @focus="txtFocus"
                                            >
                                        </div>
                                    </div>
                                </div>
                                <div class="col-xs-6">
                                    <div class="form-group">
                                        <label class="col-sm-3 control-label">拼音姓</label>
                                        <div class="col-sm-9">
                                            <input
                                                v-model="person.pinyinLastName"
                                                name="EnglishLastName"
                                                data-key="PinYinLastName"
                                                type="text"
                                                class="form-control"
                                                placeholder="必须与护照一致"
                                                autocomplete="off"
                                                @focus="txtFocus"
                                            >
                                        </div>
                                    </div>
                                </div>
                                <div class="col-xs-6">
                                    <div class="form-group">
                                        <label class="col-sm-3 control-label">拼音名</label>
                                        <div class="col-sm-9">
                                            <input
                                                v-model="person.pinyinFirstName"
                                                name="EnglishFirstName"
                                                data-key="PinYinFirstName"
                                                type="text"
                                                class="form-control"
                                                placeholder="必须与护照一致"
                                                autocomplete="off"
                                                @focus="txtFocus"
                                            >
                                        </div>
                                    </div>
                                </div>
                                <div class="col-xs-6">
                                    <div class="form-group">
                                        <label class="col-sm-3 control-label">性别</label>
                                        <div class="col-sm-9">
                                            <label class="radio_box radio-inline" data-key="Gender" @click="selectGender('M')">
                                                <input type="radio" name="sexOption" value="M" hidden :checked="person.gender === 'M'">
                                                <label class="radio-beauty"></label><span>男</span>
                                            </label>
                                            <label class="radio_box radio-inline" data-key="Gender" @click="selectGender('F')">
                                                <input type="radio" name="sexOption" value="M" hidden :checked="person.gender === 'F'">
                                                <label class="radio-beauty"></label><span>女</span>
                                            </label>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-xs-6">
                                    <div class="form-group">
                                        <label class="col-sm-3 control-label">出生日期</label>
                                        <div class="col-sm-9">
                                            <input
                                                v-model="person.dateOfBirth"
                                                name="birthDateCreate"
                                                data-key="DateOfBirth"
                                                type="text"
                                                class="form-control"
                                                id="birthday_input"
                                                placeholder="必须与护照一致"
                                                autocomplete="off"
                                                @click="showBirthCalender"
                                            >
                                            <img src="https://resource.rcclchina.com.cn/tui2/info/calandar.png" class="calendar-icon" alt="" @click="showBirthCalender">
                                            <!--日期控件-->
                                            <div v-if="isShowBirthCalender" class="calendar" id="birthCalendar">
                                                <rccl-calendar
                                                    :defaultDate="person.dateOfBirth"
                                                    :allowPreYear="true"
                                                    @onDateClicked="handleBirthDate"
                                                ></rccl-calendar>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-xs-12">
                                    <div class="form_title">选填项</div>
                                </div>
                                <div class="col-xs-6">
                                    <div class="form-group">
                                        <label class="col-sm-3 control-label">护照号</label>
                                        <div class="col-sm-9">
                                            <input
                                                v-model="person.passportNum"
                                                name="passportNum"
                                                data-key="PassPortNum"
                                                class="form-control createInfo_passportNum"
                                                type="text"
                                                placeholder="请输入护照号码"
                                                autocomplete="off"
                                                @focus="txtFocus"
                                            >
                                        </div>
                                    </div>
                                </div>
                                <div class="col-xs-6">
                                    <div class="form-group">
                                        <label class="col-sm-3 control-label">手机号</label>
                                        <div class="col-sm-9">
                                            <input
                                                v-model="person.telephone"
                                                name="phone"
                                                data-key="Telephone"
                                                type="text"
                                                class="form-control"
                                                placeholder="请输入手机号"
                                                autocomplete="off"
                                                @focus="txtFocus"
                                            >
                                        </div>
                                    </div>
                                </div>
                                <div class="col-xs-6">
                                    <div class="form-group">
                                        <label class="col-sm-3 control-label">有效期</label>
                                        <div class="col-sm-9">
                                            <input
                                                v-model="person.passportExpirationDate"
                                                name="passportExpirationDate"
                                                data-key="PassPortExpirationDate"
                                                type="text"
                                                class="form-control createInfo_passportDate"
                                                id="validInput"
                                                placeholder="请输入护照有效期"
                                                autocomplete="off"
                                                @click="showPassportCalender"
                                            >
                                            <img src="https://resource.rcclchina.com.cn/tui2/info/calandar.png" class="calendar-icon" alt="" @click="showPassportCalender">
                                            <!--日期控件-->
                                            <div v-if="isShowPassportCalender" class="calendar" id="validCalendar">
                                                <rccl-calendar
                                                    :defaultDate="person.passportExpirationDate"
                                                    :allowPreYear="false"
                                                    @onDateClicked="handlePassportDate"
                                                ></rccl-calendar>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-xs-6">
                                    <div class="form-group">
                                        <label class="col-sm-3 control-label">Email</label>
                                        <div class="col-sm-9">
                                            <input
                                                v-model="person.email"
                                                name="email"
                                                type="email"
                                                data-key="Email"
                                                class="form-control"
                                                placeholder="请输入电子邮箱"
                                                autocomplete="off"
                                                @focus="txtFocus"
                                            >
                                        </div>
                                    </div>
                                </div>
                                <div class="form_check">
                                    <i
                                        class="check_box saveDefault"
                                        v-bind:class="{cur: person.isDefaultContact}"
                                        @click="checkDefault"
                                    ></i>保存为默认联系人
                                </div>
                            </div>
                        </form>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-default" @click="close">取消</button>
                        <button type="button" class="btn btn-primary createInfo__saveBtn" @click="submit">保存</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import api from '@/api'
    import { delayDev, isChinese, isLetter, checkTel, checkMail, checkPassport } from '@/utilities/tools'
    import RcclCalendar from '@/components/Common/RcclCalendar'

    export default {
        name: 'ContactEdit',
        components: {
            RcclCalendar
        },
        data: () => {
            return {
                isShow: false,
                isShowModal: false,
                token: '',
                title: '',
                person: {},
                personOriginal: {},
                type: 1, // 1新增  2编辑
                nationList: [],
                isShowBirthCalender: false,
                isShowPassportCalender: false,
                isCur: false,
                updateFields: [],
                isMaskValue: true
            }
        },
        watch: {
            isShow (newVal) {
                if (newVal) {
                    delayDev(100, () => {
                        this.isShowModal = true
                    })
                } else {
                    this.isShowModal = false
                }
                this.updateFields = []
                this.isMaskValue = this.$store.state.page.isMaskValue;
            }
        },
        beforeMount () {
            this.init()
        },
        methods: {
            async init () {
                this.token = this.$store.state.user.userToken
                this.nationList = await this.getCountry(this.token)
            },
            show (item) {
                this.isShow = true
                document.body.style.overflow = 'hidden'
                if (item) {
                    this.title = '编辑'
                    this.type = 2
                    this.person = Object.assign({}, this.person, item)
                    this.personOriginal = Object.assign({}, item);
                    this.person.country = item.country ? item.country : 'CN'
                } else {
                    this.title = '新增'
                    this.type = 1
                    this.person.country = 'CN'
                }
            },
            selectGender (gender) {
                this.person.gender = gender
                if(!this.updateFields.includes("Gender")) {
                  this.updateFields.push("Gender")
                }
            },
            showBirthCalender () {
                if(this.isMaskValue && !this.updateFields.includes("DateOfBirth")) {
                  this.person.dateOfBirth = '';
                  this.updateFields.push("DateOfBirth");
                }
                this.isShowBirthCalender = true
            },
            handleBirthDate (date) {
                if (date) {
                  this.person.dateOfBirth = date
                  this.updateFields.push("DateOfBirth");
                }
                this.isShowBirthCalender = false
            },
            showPassportCalender () {
                if(this.isMaskValue && !this.updateFields.includes("PassPortExpirationDate")) {
                  this.person.passportExpirationDate = '';
                  this.updateFields.push("PassPortExpirationDate");
                }
                this.isShowPassportCalender = true
            },
            handlePassportDate (date) {
                if (date) {
                  this.person.passportExpirationDate = date
                  this.updateFields.push("PassPortExpirationDate");
                }
                this.isShowPassportCalender = false
            },
            checkDefault () {
                const status = !this.person.isDefaultContact
                this.person = Object.assign({}, this.person, {
                    isDefaultContact: status
                })
            },
            async handlerLastName () {
                if (!this.person.chineseLastName || this.person.chineseLastName.length == 0) {
                    return
                }
                const data = await this.getPinYin(this.person.chineseLastName)
                if (!data || data.length == 0) {
                    return
                }
                this.person = Object.assign({}, this.person, {
                    pinyinLastName: data
                })
            },
            async handlerFirstName () {
                if (!this.person.chineseFirstName || this.person.chineseFirstName.length == 0) {
                    return
                }
                const data = await this.getPinYin(this.person.chineseFirstName)
                if (!data || data.length == 0) {
                    return
                }
                this.person = Object.assign({}, this.person, {
                    pinyinFirstName: data
                })
            },
            close () {
                this.person = {}
                this.isShow = false
                document.body.style.overflow = 'auto'
            },
            getCountryArea(country){
              return country==="CN" ||
                  country === "HK" ||
                  country === "MAC" ||
                  country === "TWN";
            },
            async submit () {
              let isCN = this.getCountryArea(this.person.country)
              if(this.updateFields.length === 0) {
                this.$alert.show('没有任何修改')
                return false
              }
              if (!this.person.country) {
                  this.$alert.show('请选择国家或地区')
                  return false
              }
              if(isCN){
                if (!this.person.chineseLastName) {
                  this.$alert.show('请输入中文姓')
                  return false
                }

                if (!this.person.chineseFirstName) {
                  this.$alert.show('请输入中文名')
                  return false
                }

                if(!this.isMaskValue || this.updateFields.includes("ChineseLastName")) {
                  if (!isChinese(this.person.chineseLastName)) {
                    this.$alert.show('请输入正确的中文姓或中文名')
                    return false
                  }
                }

                if(!this.isMaskValue || this.updateFields.includes("ChineseFirstName")) {
                  if (!isChinese(this.person.chineseFirstName)) {
                    this.$alert.show('请输入正确的中文姓或中文名')
                    return false
                  }
                }
              }

              if (!this.person.pinyinLastName) {
                  this.$alert.show('请输入英文姓')
                  return false
              }
              if (!this.person.pinyinFirstName) {
                  this.$alert.show('请输入英文名')
                  return false
              }

              // if (!isLetter(this.person.pinyinLastName) || !isLetter(this.person.pinyinFirstName)) {
              //     this.$alert.show('请输入正确的拼音姓或拼音名')
              //     return false
              // }

              if(!this.isMaskValue || this.updateFields.includes("PinyinLastName")) {
                if (!isLetter(this.person.pinyinLastName)) {
                  this.$alert.show('请输入正确的拼音姓或拼音名')
                  return false
                }
              }

              if(!this.isMaskValue || this.updateFields.includes("PinyinFirstName")) {
                if (!isLetter(this.person.pinyinFirstName)) {
                  this.$alert.show('请输入正确的拼音姓或拼音名')
                  return false
                }
              }

              if (!this.person.gender) {
                  this.$alert.show('请选择性别')
                  return false
              }
              if (!this.person.dateOfBirth) {
                  this.$alert.show('请输入出生日期')
                  return false
              }

              if(!this.isMaskValue || this.updateFields.includes("Telephone")) {
                if (this.person.telephone && this.person.telephone.length > 0 && !checkTel(this.person.telephone)) {
                    this.$alert.show('请输入正确的手机号码');
                    return false;
                }
              }

              if(!this.isMaskValue || this.updateFields.includes("Email")) {
                if (this.person.email && this.person.email.length > 0 && !checkMail(this.person.email)) {
                    this.$alert.show('请输入正确的邮箱');
                    return false;
                }
              }

              if(!this.isMaskValue || this.updateFields.includes("PassPortNum")) {
                if (this.person.passportNum && this.person.passportNum.length > 0 && !checkPassport(this.person.passportNum)) {
                    this.$alert.show('请输入正确的护照号');
                    return false;
                }
              }

              if (!this.isMaskValue) {
                if(this.updateFields.includes('ChineseLastName') && !this.updateFields.includes('PinYinLastName')) {
                  this.updateFields.push('PinYinLastName')
                }
                if(this.updateFields.includes('ChineseFirstName') && !this.updateFields.includes('PinYinFirstName')) {
                  this.updateFields.push('PinYinFirstName')
                }
              }

              // 执行
              this.$loading.show()
              if (this.type === 1) {
                  const data = await this.createContact()
                  this.$loading.hide()
                  this.$emit('on-change', data)
              } else if (this.type === 2) {
                  await this.updateContact()
                  this.$loading.hide()
                  this.$emit('on-change')
              }
              this.close()
            },
            async getPinYin (name) {
                try {
                    const { data, success } = await api.page.getPinyin(name)
                    if (success) {
                        return data
                    }
                } catch (error) {
                    console.log(error)
                }
                return ""
            },
            countryClick() {
              if(!this.updateFields.includes("Country")) {
                this.updateFields.push("Country")
              }
            },
            async getCountry (userName) {
                const {success, data, errMsg} = await api.user.userEditInfo(userName)
                if (!success) {
                    console.log(errMsg)
                    return null
                } else {
                    return data.nationalityApiViews
                }
            },
            async updateContact () {
                const { errMsg, success } = await api.user.updateContact({
                    userName: this.token,
                    telephone: this.person.telephone,
                    gender: this.person.gender,
                    email: this.person.email,
                    dateOfBirth: this.person.dateOfBirth,
                    pinYinLastName: this.person.pinyinLastName,
                    pinYinFirstName: this.person.pinyinFirstName,
                    chineseFirstName: this.person.chineseFirstName,
                    chineseLastName: this.person.chineseLastName,
                    passPortNum: this.person.passportNum,
                    passPortExpirationDate: this.person.passportExpirationDate,
                    country: this.person.country,
                    isDefaultContact: this.person.isDefaultContact,
                    id: this.person.id,
                    UpdateFields: this.updateFields
                })
                if (success) {
                    return true
                } else {
                    this.$alert.show(errMsg)
                    return false
                }
            },
            async createContact () {
                const { errMsg, data, success } = await api.user.createContact({
                    userName: this.token,
                    telephone: this.person.telephone,
                    gender: this.person.gender,
                    email: this.person.email,
                    dateOfBirth: this.person.dateOfBirth,
                    pinYinLastName: this.person.pinyinLastName,
                    pinYinFirstName: this.person.pinyinFirstName,
                    chineseFirstName: this.person.chineseFirstName,
                    chineseLastName: this.person.chineseLastName,
                    passPortNum: this.person.passportNum,
                    passPortExpirationDate: this.person.passportExpirationDate,
                    country: this.person.country,
                    isDefaultContact: this.person.isDefaultContact,
                    UpdateFields: this.updateFields
                })
                if (success) {
                    return data
                } else {
                    this.$alert.show(errMsg)
                    return null
                }
            },
            txtFocus(e) {
              let dataKey = e.target.getAttribute('data-key')
              if(this.isMaskValue) {
                if(dataKey === 'ChineseLastName' || dataKey === 'PinYinLastName') {
                  if(!this.updateFields.includes("ChineseLastName") || !this.updateFields.includes("PinYinLastName")) {
                    this.person.chineseLastName = "";
                    this.person.pinyinLastName = "";
                    this.updateFields.push("ChineseLastName");
                    this.updateFields.push("PinYinLastName");
                  }
                }

                if (dataKey === 'ChineseFirstName' || dataKey === 'PinYinFirstName') {
                  if(!this.updateFields.includes("ChineseFirstName") || !this.updateFields.includes("PinYinFirstName")) {
                    this.person.chineseFirstName = "";
                    this.person.pinyinFirstName = "";
                    this.updateFields.push("ChineseFirstName");
                    this.updateFields.push("PinYinFirstName");
                  }
                }

                // if(dataKey === 'PassPortExpirationDate') {
                //   if(!this.updateFields.includes("PassPortExpirationDate")) {
                //     this.person.passportExpirationDate = "";
                //     this.updateFields.push("PassPortExpirationDate");
                //   }
                // }
                //
                // if(dataKey === 'DateOfBirth') {
                //   if(!this.updateFields.includes("DateOfBirth")) {
                //     this.person.dateOfBirth = "";
                //     this.updateFields.push("DateOfBirth");
                //   }
                // }

                if(!this.updateFields.includes(dataKey)) {
                  Object.keys(this.person).filter(r => {
                    if (dataKey.toUpperCase() === r.toUpperCase()) {
                      this.person[r] = "";
                      return r
                    }
                  });
                }
              }

              if(dataKey !== 'PassPortExpirationDate' && dataKey !== 'DateOfBirth') {
                console.log('dddd')
                if(!this.updateFields.includes(dataKey)) {
                  this.updateFields.push(dataKey);
                }
              }

              console.log(this.updateFields)
            }
        }
    }
</script>

<style lang="less" scoped>
    .add-form-modal {
        background-color: rgba(0,0,0,0.5);
        overflow: auto;
        &.active {
            display: block;
        }
        .modal-body {
            padding: 0;
            .coupon_modal_hd {
                font-size: 22px;
                color: #282b2c;
                padding: 16px 20px;
            }
            .coupon_modal_bd {
                padding: 0 26px 30px;
                .form-horizontal {
                    .control-label {
                        padding: 7px 0;
                        color: #747d80;
                        font-weight: normal;
                        font-size: 14px;
                        width:70px;
                    }
                    .form-control {
                        border-radius: 0;
                        border: none;
                        border-bottom: 1px solid #d3dadd;
                        box-shadow: none;
                        font-style: normal;
                        position: relative;
                        z-index: 1;
                        background: transparent;
                    }
                    .form_title {
                        width: 100%;
                        background: #f3f6f8;
                        font-size: 12px;
                        color: #747d80;
                        line-height: 24px;
                        height: 24px;
                        border-radius: 10px;
                        text-align: center;
                        margin: 10px 0px 20px;
                    }
                }
                .radio-beauty {
                    margin: 0;
                    vertical-align: middle;
                }
                input[type="radio"] + label::before {
                    margin: 0;
                }
                .form_check {
                    padding-left: 70px;
                    .check_box {
                        width: 18px;
                        height: 18px;
                        border: 1px solid #d3dadd;
                        display: inline-block;
                        vertical-align: middle;
                        margin-right: 10px;
                        cursor: pointer;
                        &.cur {
                            background: url(../../assets/icon-checkBox-checked.png) no-repeat center;
                            border-color: #006ab9;
                        }
                    }
                }
            }
            .modal-footer {
                text-align: center;
                background: #f3f6f8;
                border-top: 1px solid #ddd;
                border-radius: 0 0 6px 6px;
                button {
                    border-radius: 0;
                    width: 80px;
                    margin: 0 4px;
                    outline: none;
                }
                .btn-primary {
                    background: #006ab9;
                }
            }
        }
    }

    .delete_btn {
        cursor: pointer;
    }

    input[type="radio"] + label {
        width: 0;
    }

    input[type="radio"]:checked + label::before {
        background-color: #006ab9;
        background-clip: content-box;
        padding: 3px;
    }

    input[type="radio"] + label::before {
        content: "";
        background: #fff;
        border: 1px solid #c2c7cb;
        width: 15px;
        height: 15px;
        border-radius: 50%;
        float: left;
        margin-right: 6px;
        margin-top: 2px;
    }

    .radio-inline {
        width: 64px;
        height: 26px;
    }

    .radio-beauty + span {
        padding-left: 30px;
    }
    .calendar-icon {
        width: 20px;
        height: 20px;
        position: absolute;
        bottom: 6px;
        right: 20px;
        z-index: 3;
        cursor: pointer;
    }

    .nationality {
        border: none;
        outline: none;
        border-bottom: solid 1px #d3dadd;
        vertical-align: 0;
        font-style: normal;
        -webkit-appearance: none;
        background: url(https://resource.rcclchina.com.cn/tui2/list/icon-down.png) 208px center no-repeat;
        background-size: 12px;
        padding: 6px 96px 6px 12px;
        margin-bottom: 10px;
        margin-left: 12px;
    }

    .calendar {
        z-index: 2;
        margin-top: 0;
    }

    .year-dropdown {
        height: 250px;
        overflow-x: hidden;
    }

    .month-dropdown {
        max-height: 250px;
        overflow-x: hidden;
    }
</style>
